import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const NotFound = () => (
  <div className="page">
    <header className="page-head animate-in">
      <h1 className="page-head__title">
        <span className="gradient-text">404</span>
      </h1>
      <p className="lede">
        No trace found for that path. Nothing was instrumented here.
      </p>
      <p style={{ marginTop: 28 }}>
        <Link className="btn" to="/">
          <FiArrowLeft /> Back home
        </Link>
      </p>
    </header>
  </div>
);

export default NotFound;
